import formapimodalfollowups from "./followups";

export default function formapimodalfollowupsPagination({
    data,
    pageno,
    pagesize,
    count
  })
  {
  return Object.freeze({
    
    data:data !== null ? formapimodalfollowups(data) : [],
    pageno,
    pagesize,
    count,
  });
  }